import React, { ReactNode } from 'react';
import { Theme } from 'theme/theme.types';
import { ChakraProvider } from '@chakra-ui/react';

export const withTheme = (children: ReactNode, theme: Theme): JSX.Element => {
  return theme ? <ChakraProvider theme={theme}>{children}</ChakraProvider> : <>{children}</>;
};
